import moment from 'moment'

export const formatDate = (date, format = 'MM/DD/YYYY') => moment(date, 'YYYY-MM-DD HH:mm:ss a').format(format)

export const isDateAfterToday = date => moment(date, 'YYYY-MM-DD HH:mm:ss a').isAfter(moment())

export const pgaTld = window.location.origin.includes('.sandboxpga.org') || window.location.origin.includes('.pga.local') ? 'sandboxpga.org' : 'pga.org'
export const myPgaTld = window.location.origin.includes('.sandboxpga.org') || window.location.origin.includes('.pga.local') ? 'my.dev.pga.com' : 'my.pga.com'

export const buildMyPgaUrl = (path, slug) => {
  return `https://${myPgaTld}/${path}/${slug}`
}
